import {memo} from 'react';
import {styled, css, keyframes} from 'styled-components';
import {forbidExtraProps} from 'airbnb-prop-types';
import {number, string} from 'prop-types';

const spinnerAnimation = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1.0);
  }
`;

const Wr = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    width: ${props => props.$size}px;
    height: ${props => props.$size}px;
    background: ${props => props.$color};
  }
`;

const dotStyle = css`
  border-radius: 100%;
  animation: ${spinnerAnimation} 1.4s infinite ease-in-out both;
`;

const DotTransparent = styled.div`
  ${dotStyle}
  visibility: hidden;
`;

const Dot1 = styled.div`
  ${dotStyle}
  animation-delay: -0.32s;
`;

const Dot2 = styled.div`
  ${dotStyle}
  animation-delay: -0.16s;
`;

const Dot3 = styled.div`
  ${dotStyle}
`;

export default memo(SpinnerThreeDots);

SpinnerThreeDots.propTypes = forbidExtraProps({
  color: string.isRequired,
  size: number.isRequired,
});

function SpinnerThreeDots({
  color,
  size,
}) {
  return (
    <Wr $color={color} $size={size}>
      <Dot1/>
      <DotTransparent/>
      <Dot2/>
      <DotTransparent/>
      <Dot3/>
    </Wr>
  );
}
